// @flow

import React, { Component } from 'react';
import { FormGroup, CustomInput, Label } from 'reactstrap';
import RemovableImage from './RemovableImage';
import type { FileField } from '../../../entities/types';

type PropsType = {
    id: string,
    field: FileField,
    imageIds: string[],
    imageUrls: string[],
    onImageRemove: (Event, string) => void,
    onFileUpdated: (File) => void,
};

class ImageInputField extends Component<PropsType> {
    constructor(props) {
        super(props);
        this.state = {
            label: 'Please select an image...',
        };
        this.ref = React.createRef();
    }

    onChange() {
        const currentFile = this.ref.current.files[0];
        const onFileUpdated = () => this.props.onFileUpdated(this.props.id, currentFile);
        // Send file to container after setting label
        this.setState({ label: currentFile.name }, onFileUpdated);
    }

    render() {
        const p = this.props;

        const imageComponents = [];
        p.imageIds.forEach((id, index) => {
            imageComponents.push(
                <div className="mr-2">
                    <RemovableImage key={id} imageUrl={p.imageUrls[index]} onRemoveClick={() => p.onImageRemove(id)} />
                </div>,
            );
        });

        const imagesComponent =
            imageComponents.length > 0 ? <div className="d-flex flex-row my-2">{imageComponents}</div> : null;

        return (
            <FormGroup>
                <Label for={p.id}>{p.field.displayName}</Label>
                {imagesComponent}
                <CustomInput
                    type="file"
                    id={this.props.id}
                    label={this.state.label}
                    innerRef={this.ref}
                    onChange={() => this.onChange()}
                />
            </FormGroup>
        );
    }
}

export default ImageInputField;
